<template>
    <div>
        <div class="row" v-bind:class="{ 'kt-spinner-f': loading }">
            <div class="col-md-12">
                <div class="templatepdfcontainer">
                    <!--                    <div class="row">-->
                    <!--                        <div class="col-md-12">-->
                    <!--                            <button class="btn btn-primary btn-block" v-on:click="showCoordinates" >Show PDF Placeholders-->
                    <!--                                Coordinates-->
                    <!--                            </button>-->
                    <!--                        </div>-->
                    <!--                    </div>-->
                    <div class="row">
                        <div class="col-md-12" id="pdfManager">
                            <div class="row" id="selectorContainer">
                                <div class="col-fixed-240">
                                    <b-form-group
                                    >
                                        <b-form-input
                                                id="label"
                                                v-model="label"
                                                type="text"
                                                required
                                                placeholder="Nome pdf"
                                        ></b-form-input>
                                    </b-form-group>
                                    <input @change="onFileChange" id="fileUpload" type="file" accept="application/pdf"
                                           hidden>
                                    <b-button v-if="hasPdf" v-on:click="save" class="mr-3 btn btn-primary btn-block">
                                        Salva
                                    </b-button>
                                    <b-button v-if="!hasPdf" v-on:click="uploadPdf"
                                              class="mr-3 btn btn-primary btn-block">Carica pdf
                                    </b-button>
                                    <b-button v-if="hasPdf" v-on:click="downloadPdf"
                                              class="mr-3 btn btn-info btn-block">Scarica pdf
                                    </b-button>
                                    <b-button v-on:click="cancel" class="mr-3 btn btn-warning btn-block">Indietro
                                    </b-button>
                                    <div v-if="hasPdf" style="margin-top: 0.5rem;">
                                        <click-confirm>
                                            <b-button v-on:click="uploadPdf" class="mr-3 btn btn-warning btn-block">
                                                Sostituisci pdf
                                            </b-button>
                                        </click-confirm>
                                    </div>
                                    <div v-if="hasPdf">
                                        <div class="pdf-pager">
                                            <b-button v-on:click="prevPage" class="btn btn-sm"><i
                                                    class="fa fa-angle-double-left"></i></b-button>
                                            Pagina {{ pdfPagenum }} / {{ pdf?pdf.numPages:'' }}
                                            <b-button v-on:click="nextPage" class="btn btn-sm"><i
                                                    class="fa fa-angle-double-right"></i></b-button>
                                        </div>
                                        <!--                                    <b-button v-on:click="zoomIn" class="mr-3 btn btn-warning btn-block">Zoom+</b-button>-->
                                        <!--                                    <b-button v-on:click="zoomOut" class="mr-3 btn btn-warning btn-block">Zoom-</b-button>-->
                                        <!--                                    <div  id="parametriContainer"></div>-->
                                        <div id="todragcontainer" class="todrag">
                                            <p>Trascina gli elementi nel pdf:</p>
                                            <span data-type="date" class="todrag-date drag-element drag-element-source"><span class="indrag">Data</span></span>
                                            <span data-type="signature"
                                                  class="todrag-signature drag-element drag-element-source"><span class="indrag">Firma</span></span>
                                            <span data-type="attachment"
                                                  class="todrag-attachment drag-element drag-element-source"><span class="indrag">Allegato</span></span>
                                        </div>
                                      <br>
                                      <div id="draggedelementsettings" v-if="placeHolderEditing && settings.placeholders[pdfPagenum][placeHolderEditing] && settings.placeholders[pdfPagenum][placeHolderEditing].settings">
                                          <p>Impostazioni campo:</p>
                                          <b-form-group
                                          >
                                            <b-form-input
                                                id="label"
                                                v-if="settings.placeholders[pdfPagenum][placeHolderEditing].type=='attachment'"
                                                v-model="settings.placeholders[pdfPagenum][placeHolderEditing].settings.label"
                                                type="text"
                                                required
                                                placeholder="Etichetta"
                                            ></b-form-input>
                                            <b-form-checkbox
                                                value="true"
                                                v-if="settings.placeholders[pdfPagenum][placeHolderEditing].type=='signature'"
                                                v-model="settings.placeholders[pdfPagenum][placeHolderEditing].settings.secondsignature"
                                                class="mb-2 mr-sm-2 mb-sm-0">
                                              Second signature
                                            </b-form-checkbox>
                                          </b-form-group>
                                      </div>
                                    </div>
                                </div>
                                <div v-if="hasPdf" class="col-fixed-605">
                                    <div id="pageContainer" class="pdfViewer singlePageView dropzone nopadding"
                                         style="background-color:transparent">
                                        <canvas id="the-canvas" style="border:1px  solid black"></canvas>
                                        <div id="annotation-layer"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        </div>
    </div>
</template>
<style>
    .templatepdfcontainer #pageContainer {
        overflow: hidden;
        max-height: 1000px;
        z-index: -1;
        position: relative;
    }

    .templatepdfcontainer #messageContainer {
        display: none;
    }

    .templatepdfcontainer #outer-dropzone {
        height: 140px;
        touch-action: none;
    }

    .templatepdfcontainer #inner-dropzone {
        height: 80px;
    }

    .templatepdfcontainer .dropzone {
        background-color: #ccc;
        border: dashed 4px transparent;
        border-radius: 4px;
        margin: 10px auto 30px;
        padding: 10px;
        width: 100%;
        transition: background-color 0.3s;
    }

    .templatepdfcontainer .drop-active {
        border-color: #aaa;
    }

    .templatepdfcontainer .drop-target {
        background-color: #29e;
        border-color: #fff;
        border-style: solid;
    }

    .templatepdfcontainer .drag-drop {
        display: inline-block;
        position: absolute;
        z-index: 10;
        min-width: 40px;
        padding: 0em 0.5em;
        padding-left: 0;
        color: #fff;
        background-color: #29e;
        border: none;
        -webkit-transform: translate(0px, 0px);
        transform: translate(0px, 0px);
        transition: background-color 0.3s;
        line-height: 10px;
        padding-right: 0 !important;
        padding-left: 5px !important;
    }

    .templatepdfcontainer .drag-drop.can-drop {
        color: #000;
        background-color: transparent;
        opacity: 0.9;
        /* IE 8 */
        -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=90)";
        /* IE 5-7 */
        filter: alpha(opacity=90);
        /* Netscape */
        -moz-opacity: 0.9;
        /* Safari 1.x */
        -khtml-opacity: 0.9;
    }

    .templatepdfcontainer .nopadding {
        padding: 0 !important;
        margin: 0 !important;
    }

    .templatepdfcontainer .circle {
        width: 10px;
        height: 10px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        background: #323c3c;
        float: left;
        display: inline-block;
        margin-top: 1px;
        margin-right: 2px;
    }

    .templatepdfcontainer .dropped-out {
        display: block;
        padding: .75rem 1.25rem;
        margin-bottom: -1px;
        background-color: #fff;
        border: 1px solid rgba(0, 0, 0, 0.125);
        width: 200px;
        color: black;
    }

    .templatepdfcontainer .col-fixed-240 {
        width: 240px;
        height: 100%;
        z-index: 8;
    }

    .templatepdfcontainer .col-fixed-605 {
        margin-left: 240px;
        width: 605px;
        height: 100%;
        z-index: 1;
    }

    .templatepdfcontainer .page-item {
        cursor: pointer;
    }

    .templatepdfcontainer .pager {
        margin-bottom: 30px !important;
        margin-top: 0px !important;
        margin-bottom: -31px !important;
    }

    .templatepdfcontainer .drag-drop.dropped-out .descrizione {
        font-size: 12px !important;
    }

    /*.templatepdfcontainer #the-canvas {*/
    /*    height: 842px;*/
    /*    width: 595px;*/
    /*}*/

    .templatepdfcontainer .todrag {
        margin-top: 20px;
    }

    span.drag-element {
        border: 1px solid #ccc;
        text-align: center;
        display: block;
        border-radius: 10px;
        padding: 20px;
        margin: 10px 0;
        text-transform: uppercase;
        cursor: move;


        -webkit-touch-callout: none; /* iOS Safari */
        -webkit-user-select: none; /* Safari */
        -khtml-user-select: none; /* Konqueror HTML */
        -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
        user-select: none;
        /* Non-prefixed version, currently
                                         supported by Chrome, Opera and Firefox */
    }

    .drag-element {
        position: absolute;
        top: 0px;
        left: 0px;
        background-color: #fff;
        border: 1px solid #ff0000;
        box-sizing:border-box;
        padding:10px;
    }

    .drag-element-source {
        position: relative;
    }

    span.drag-element.drag-element-drag .indrag{
        top: 50%;
        position: relative;
        display: block;
        margin-top: -8px;
    }
    span.drag-element.drag-element-drag {
        border-radius: 0;
        height: 50px;
        /*line-height: 25px;*/
        line-height:100%;
        width: 140px;
        border: 1px solid red;
        z-index: 999;
        touch-action: none;
        padding:4px;
        -webkit-touch-callout: none; /* iOS Safari */
        -webkit-user-select: none; /* Safari */
        -khtml-user-select: none; /* Konqueror HTML */
        -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
        user-select: none;
        /* Non-prefixed version, currently
                                         supported by Chrome, Opera and Firefox */
    }

    .templatepdfcontainer .todrag span.drag-element-drag.can-drop {
        border: 1px solid green;
    }

    .templatepdfcontainer .todrag span.drag-element-drag.todrag-signature,
    .templatepdfcontainer .todrag span.drag-element-drag.todrag-date,
    .templatepdfcontainer .todrag span.drag-element-drag.todrag-attachment {
        height: 60px;
        line-height: 100%;
        width: 200px;
    }

    .drag-element-remove {
        position: absolute;
        right: -5px;
        top: -5px;
        line-height: 0px;
        background: #fff;
        font-size: 15px;
        cursor: pointer;
        z-index: 10000;
    }

    .pdf-pager {
        margin: 10px 0;
        text-align: center;
    }

    .pdf-pager button {
        margin: 0 4px;
    }

    .dragging-container,
    .dragging-container * {
        -ms-touch-action: none;
        touch-action: none;
    }


    #annotation-layer {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        overflow: hidden;
        opacity: 0.6;
        line-height: 1.0;
        display:none;
    }

    #annotation-layer > section {
        color: transparent;
        position: absolute;
        white-space: pre;
        cursor: text;
        transform-origin: 0% 0%;
    }

    #annotation-layer > .linkAnnotation > a {
        position: absolute;
        font-size: 1em;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    #annotation-layer > div{
        background:yellow;
        white-space: nowrap;
        cursor:pointer;
    }

    #draggedelementsettings p{
      text-align: center;
      padding-top: 13px;
    }
    #draggedelementsettings,.placeholder-editing-enabled{
      background: #ffff8c;
      background: repeating-linear-gradient(
          45deg,
          #fff,
          #fff 10px,
          #ffff8c 10px,
          #ffff8c 20px
      );
    }
</style>
<script>
    import {SET_BREADCRUMB} from "../../../store/breadcrumbs.module";
    import {ADD_BODY_CLASSNAME, REMOVE_BODY_CLASSNAME} from "@/store/htmlclass.module";
    import moment from 'moment';
    // import KTPortlet from "@/views/partials/content/Portlet.vue";
    import $ from 'jquery';
    import Vue from "vue";
    import ApiService from "../../../common/api.service";
    import UserService from "../../../common/user.service";

    window.vm = {};
    window.j = $;
    export default {
        data() {
            return {
                label: '',
                loading: false,
                hasPdf: false,
                maxPDFx: 595,
                maxPDFy: 842,
                offsetY: 5,
                offsetX: 5,
                pdf: null,
                pdfScale: 1,
                pdfScaleBefore: 1,
                pdfPagenum: 1,
                placeHolderEditing: false,
                settings: {placeholders: {}}
            };
        },
        components: {},
        mounted() {

            this.$store.dispatch(SET_BREADCRUMB, [
                {title: "Documenti", route: "/document"},
                {title: "Documento", route: "/document/edit/" + this.$router.currentRoute.params.did,},
                {title: !this.isNew() ? "Modifica pdf" : 'Modifica pdf'}
            ]);
            var that = this;

            if (this.isNew()) {
                this.label = 'Template ' + moment().format('DD/MM/YYYY H:m');
            }else{
                this.reload();
            }

            window.applyRightTransformationsPlaceholder = this.applyRightTransformationsPlaceholder;
            window.storePlaceHolder = this.storePlaceHolder;
            window.enablePlaceHolderEditing = this.enablePlaceHolderEditing;
            window.disablePlaceHolderEditing = this.disablePlaceHolderEditing;

            // if (this.hasPdf) {
            //     this.loadViewerTotal();
            // }


            // let scr = document.createElement('script');
            // scr.setAttribute('src', 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.0.943/pdf.min.js');
            // document.head.appendChild(scr);
            // scr = document.createElement('script');
            // scr.setAttribute('src', 'https://cdnjs.cloudflare.com/ajax/libs/interact.js/1.2.9/interact.min.js');
            // document.head.appendChild(scr);
            // scr = document.createElement('script');
            // scr.onload = () => {
            //     // resolve(import(someComponent))
            //     pdfjsLib.GlobalWorkerOptions.workerSrc =
            //         'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.0.943/pdf.worker.min.js';
            //     this.loadViewer();
            // };
            // scr.setAttribute('src', 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.0.943/pdf.worker.min.js');
            // document.head.appendChild(scr);
        },
        methods: {
            isNew: function () {
                return !this.currentEditId();
            },
            currentEditId: function () {
                return this.$router.currentRoute.params.id;
            },
            currentDocumentEditId: function () {
                return this.$router.currentRoute.params.did;
            },
            loadConfiguration:function(conf){
                let that = this;
                let s = 1;
                $.each(conf,(type,v1)=>{
                    let t = null;
                    if(type=='signatures'){
                        t  = 'signature';
                    }
                    if(type=='dates'){
                        t  = 'date';
                    }
                    if(type=='attachments'){
                        t  = 'attachment';
                    }
                    if(t){
                        $.each(v1,(el,v2)=>{
                            if(!that.settings.placeholders[v2.page]){
                                that.settings.placeholders[v2.page] = [];
                            }
                            let eldata = {
                              type:t,
                              position:{
                                x:v2.x,
                                y:v2.y,
                                width:v2.width,
                                height:v2.height,
                              }
                            };
                            if(v2.yOS){
                              // OpenSign position
                              eldata.position.yOS = v2.yOS;
                            }
                            if(v2.label){
                              eldata.settings = {label:v2.label};
                            }
                            if(v2.secondsignature){
                              eldata.settings = {secondsignature:v2.secondsignature};
                            }
                            that.settings.placeholders[v2.page][s++]= eldata;
                        });
                    }
                });
            },
            getPostConfiguration:function(){
                let data = {

                };
                let that =this;
                // Add signatures
                $.each(that.settings.placeholders,(page,v1)=>{
                    if(!v1 || page==='undefined'){
                        return;
                    }
                    $.each(v1,(element,v2)=>{
                        if(!v2){
                            return;
                        }
                        let type = null;
                        if(v2.type=='signature'){
                            type = 'signatures';
                        }
                        if(v2.type=='date'){
                            type = 'dates';
                        }
                        if(v2.type=='signature'||v2.type=='signatures'){
                          // if(!v2.settings || !v2.settings.secondsignature){
                          //   v2.settings = {'secondsignature':null};
                          //   // v2.settings = {};
                          // }
                        }
                        if(v2.type=='attachment'){
                            type = 'attachments';
                            if(!v2.settings || !v2.settings.label){
                              v2.settings = {'label':'-'};
                            }
                        }
                        if(type){
                            if(!data[type]){
                                data[type] = [];
                            }
                            let eldata = {
                              page:page,
                              x: v2.position.x,
                              y: v2.position.y,
                              width: v2.position.width,
                              height: v2.position.height,
                            };
                            if(v2.position.yOS){
                              eldata.yOS = v2.position.yOS;
                            }
                            if(v2.settings && v2.settings.label){
                              eldata.label = v2.settings.label;
                            }
                            if(v2.settings && v2.settings.secondsignature){
                              eldata.secondsignature = true;
                            }
                            data[type].push(eldata);
                        }
                    });
                });

                return data;
            },
            save: function () {
                this.loading=true;
                let that = this;
                ApiService.post('templates' + (that.isNew() ? '' : '/' + that.currentEditId()), {
                    'label': that.label,
                    'configuration': this.getPostConfiguration(),
                    'contract_configuration_id': that.currentDocumentEditId(),
                })
                    .then(({data}) => {
                        Vue.customNotifySuccess('Salvato');
                        // that.loading = false;
                        // that.reload();
                        this.$router.push({ name: "document-edit", 'params':{'id':that.currentDocumentEditId()} });

                    })
                    .catch(({response}) => {
                        //context.commit(SET_ERROR, response.data.errors);
                        Vue.customNotifyError('Errore', response.data && response.data.errors ? response.data.errors.join(', ') : 'Si prega di riprovare');
                    });
                // this.$router.push({name: "document-edit", params: {id: this.currentDocumentEditId()}});
            },
            uploadPdf: function () {
                document.getElementById("fileUpload").click()
            },
            downloadPdf: function () {
                const byteCharacters = this.pdfData;
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                var blob = new Blob([byteArray], { type: 'application/pdf' });
                if (window.navigator.msSaveBlob) { // // IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx
                    window.navigator.msSaveOrOpenBlob(blob, 'exportData' + new Date().toDateString() + '.pdf');
                }
                else {
                    var a = window.document.createElement("a");
                    a.href = window.URL.createObjectURL(blob, { type: "application/pdf" });
                    a.download = "exportData" + new Date().toDateString() + ".pdf";
                    document.body.appendChild(a);
                    a.click();  // IE: "Access is denied"; see: https://connect.microsoft.com/IE/feedback/details/797361/ie-10-treats-blob-url-as-cross-origin-and-denies-access
                    document.body.removeChild(a);
                }
            },
            onFileChange(e) {
                var files = e.target.files || e.dataTransfer.files;
                if (!files.length)
                    return;
                this.loading = true;
                let file = files[0];
                let that = this;
                var reader = new FileReader();
                reader.readAsBinaryString(file);
                reader.onload = function () {
                    //console.log(btoa(reader.result));
                    ApiService.post('templates' + (that.isNew() ? '' : '/' + that.currentEditId()), {
                        'label': that.label,
                        'file': btoa(reader.result),
                        'configuration': {},
                        'contract_configuration_id': that.currentDocumentEditId(),
                    })
                        .then(({data}) => {
                            if (that.isNew()) {
                                Vue.customNotifySuccess('Salvato');
                                //that.$router.push({ name: "document-edit", 'params':{'id':data.id} });
                                console.log('daaata',data);
                                that.$router.currentRoute.params.id = data.id;
                                that.$router.push({
                                    name: "document-edit-template",
                                    'params': {'did': that.currentDocumentEditId(), 'id': data.id}
                                });
                                that.loading = false;
                                that.reload();
                            } else {
                                Vue.customNotifySuccess('Salvato');
                                that.loading = false;
                                that.reload();
                            }
                            //
                            //
                            //https://bootstrap-vue.js.org/docs/components/toast/
                            // this.$bvToast.toast(`This is toast number ${this.toastCount}`, {
                            //     title: 'BootstrapVue Toast',
                            //     autoHideDelay: 5000,
                            //     appendToast: append
                            // })

                        })
                        .catch(({response}) => {
                            //context.commit(SET_ERROR, response.data.errors);
                            Vue.customNotifyError('Errore', response.data && response.data.errors ? response.data.errors.join(', ') : 'Si prega di riprovare');
                        });
                };
                reader.onerror = function () {
                    //console.log('there are some problems');
                    Vue.customNotifyError('Errore, Si prega di riprovare');
                };
                //this.createImage(files[0]);
            },
            reload: function () {
                this.loading = true;
                Promise.all(
                    [
                        new Promise(resolve => {
                            ApiService.get('templates' + '/' + this.currentEditId())
                                .then(({data}) => {
                                    this.label = data.label;
                                    this.loadConfiguration(JSON.parse(data.configuration));
                                    resolve(data);
                                })
                                .catch(({response}) => {
                                    Vue.customNotifyError('Errore', response.data && response.data.errors ? response.data.errors.join(', ') : 'Si prega di riprovare');
                                });
                        }),
                        new Promise(resolve => {
                            ApiService.get('templates' + '/file/' + this.currentEditId())
                                .then(({data}) => {
                                    this.pdfData = atob(data.file);
                                    this.hasPdf = true;
                                    resolve(data);
                                })
                                .catch(({response}) => {
                                    Vue.customNotifyError('Errore', response.data && response.data.errors ? response.data.errors.join(', ') : 'Si prega di riprovare');
                                });
                        }),
                    ]).then(()=>{
                        this.loading=false;
                        this.loadConfiguration();
                        this.loadViewerTotal();
                    });

            },
            cancel: function () {
                // this.$router.push({name: "document-edit",params:{id:this.currentEditId()}});
                // this.$router.go(-1);
                this.$router.push({ name: "document-edit", 'params':{'id':this.currentDocumentEditId()} });
            }
            ,
            nextPage: function () {
                if (this.pdfPagenum >= this.pdf.numPages) {
                    return;
                }
                this.pdf.getPage(++this.pdfPagenum).then(page => {
                    this.render(page);
                    this.drawPlaceHolders();
                });
            }
            ,
            prevPage: function () {
                if (this.pdfPagenum <= 1) {
                    return;
                }
                this.pdf.getPage(--this.pdfPagenum).then(page => {
                    this.render(page);
                    this.drawPlaceHolders();
                });
            }
            ,
            zoomOut: function () {
                if (this.pdfScale <= 0.5) {
                    return;
                }
                this.pdfScale = this.pdfScale - 0.25;
                this.pdf.getPage(this.pdfPagenum).then(page => this.render(page));
            }
            ,
            zoomIn: function () {
                if (this.pdfScale > 3.75) {
                    return;
                }
                this.pdfScale = this.pdfScale + 0.25;
                this.pdf.getPage(this.pdfPagenum).then(page => this.render(page));
            }
            ,
            applyRightTransformationsPlaceholder: function (node) {
                return node;
            }
            ,
            removePlaceHolder: function (node) {
                if (!this.settings.placeholders[this.pdfPagenum] || !this.settings.placeholders[this.pdfPagenum][$(node).data('id')]) {
                    return;
                }
                window.disablePlaceHolderEditing();
                delete this.settings.placeholders[this.pdfPagenum][$(node).data('id')];
            }
            ,
            wrapNode: function (node) {
                var that = this;
                // Add deletable attribute
                $(node).append($('<span>').addClass('drag-element-remove').html('<i class="fa fa-window-close"></i>').click((e) => {
                    var el = $(e.currentTarget).parent();
                    that.removePlaceHolder(el.eq(0));
                    el.remove();
                }));
                $(node).click(function(e){
                  let el = $(this);
                  window.enablePlaceHolderEditing(this);
                });
            }
            ,
            enablePlaceHolderEditing: function (node) {
              let id = $(node).data('id');
              let type = $(node).data('type');
              if(id && (type==='attachment' || type=='signature')){
                $('.placeholder-editing-enabled').removeClass('placeholder-editing-enabled');
                $(node).addClass('placeholder-editing-enabled');
                this.placeHolderEditing = id;
                if(this.settings.placeholders[this.pdfPagenum][this.placeHolderEditing].type=='signature'){
                  if(!this.settings.placeholders[this.pdfPagenum][this.placeHolderEditing].settings){
                    this.settings.placeholders[this.pdfPagenum][this.placeHolderEditing].settings = {
                      'secondsignature':null
                    };
                  }
                }
              }else{
                window.disablePlaceHolderEditing();
              }
            }
            ,
            disablePlaceHolderEditing: function (node) {
              $('.placeholder-editing-enabled').removeClass('placeholder-editing-enabled');
              this.placeHolderEditing = false;
            }
            ,
            storePlaceHolder: function (node) {
                if (!this.settings.placeholders[this.pdfPagenum]) {
                    this.settings.placeholders[this.pdfPagenum] = [];
                }
                var x = parseFloat(node.getAttribute('data-x'));
                var y = parseFloat(node.getAttribute('data-y'));
                var maxHTMLx = $('#the-canvas').width();
                var maxHTMLy = $('#the-canvas').height();
                // // var paramContainerWidth = $('#parametriContainer').width();
                var maxPDFx = this.maxPDFx;
                var maxPDFy = this.maxPDFy;
                var offsetY = this.offsetY;
                var offsetX = this.offsetX;
                let pdfXRatio = this.pdfScale;//maxPDFx / maxHTMLx;
                let pdfYRatio = this.pdfScale;// maxPDFy / maxHTMLy;
                // var pdfY = y * maxPDFy / maxHTMLy;
                // var pdfX = (x * maxPDFx / maxHTMLx);
                // var posizioneY = maxPDFy - offsetY - pdfY;
                // var posizioneX = $('#pageContainer').position().left - pdfX;
                let positionX = (x - offsetX - $('#pageContainer').position().left) * pdfXRatio;
                let positionY = (maxHTMLy - offsetY - (y - $('#pageContainer').position().top)) * pdfYRatio;
                let positionYOS = (offsetY + (y - $('#pageContainer').position().top)) * pdfYRatio;
                let width = ($(node).outerWidth())*pdfXRatio;
                let height = ($(node).outerHeight())*pdfYRatio;
                //positionY-=40; // strange fix for namirial
                positionY-=(($(node).outerHeight())*pdfYRatio);
                let settings = {
                    position: {
                        x: positionX,
                        y: positionY,
                        yOS: positionYOS,
                        width: width,
                        height: height,
                    },
                    type: $(node).data('type'),
                };
                let id = null;
                if ($(node).data('id')) {
                    id = $(node).data('id');
                    if(this.settings.placeholders[this.pdfPagenum][id].settings){
                      settings.settings = this.settings.placeholders[this.pdfPagenum][id].settings;
                    }
                } else {
                    let max = Object.keys(this.settings.placeholders[this.pdfPagenum]).length ? Object.keys(this.settings.placeholders[this.pdfPagenum]).reduce((a, b) => parseInt(this.settings.placeholders[this.pdfPagenum][a]) > parseInt(this.settings.placeholders[this.pdfPagenum][b]) ? a : b) : 0;
                    id = parseInt(max) + 1;
                    this.wrapNode(node);
                }
                if(settings.type=='attachment' && !settings.settings){
                  // alert('reset');
                  settings.settings = {
                    'label': 'Allegato'
                  };
                  console.warn('settings default',id);
                }
                this.settings.placeholders[this.pdfPagenum][id] = settings;

                // $(node).resizable();

                $(node).data('id', id);
                console.log('settings', this.settings, settings, settings.position.x, settings.position.y);
            }
            ,
            drawPlaceHolders: function () {
                window.disablePlaceHolderEditing();
                // Remove existing placeholders
                $('.drag-element-drag').remove();
                // Draw those of current page
                let pdfXRatio = this.pdfScale;//maxPDFx / maxHTMLx;
                let pdfYRatio = this.pdfScale;// maxPDFy / maxHTMLy;
                var maxHTMLy = $('#the-canvas').height();
                if (this.settings.placeholders[this.pdfPagenum]) {
                    this.settings.placeholders[this.pdfPagenum].forEach((ob, id) => {
                        var text = ob.type == 'attachment' ? 'Allegato' : (ob.type == 'signature' ? 'Firma' : (ob.type == 'date' ? 'Data' : ''));
                        let x = ob.position.x / pdfXRatio + this.offsetX + $('#pageContainer').position().left;
                        let y = -ob.position.y / pdfYRatio + maxHTMLy - this.offsetY + $('#pageContainer').position().top;
                        y-=((ob.position.height)/pdfYRatio);
                        //y-=40; // strange fix for namirial
                        var n = $('<span>').data('type', ob.type).addClass('todrag-' + ob.type + ' drag-element drag-element-drag can-drop').attr('data-x', x).attr('data-y', y).data('x', x).data('y', y).css('transform', 'translate(' + x + 'px, ' + y + 'px)').text(text).data('id', id).attr('data-id',id)
                            .width((ob.position.width)/pdfXRatio).height((ob.position.height)/pdfYRatio);
                        this.wrapNode(n.get(0));
                        document.getElementById('todragcontainer').appendChild(n.get(0));
                    });
                }
                this.$forceUpdate(); // todo fix later
            }
            ,
            render: function (page) {
                var that = this;
                var viewport = page.getViewport(this.pdfScale);
                //
                // Prepare canvas using PDF page dimensions
                //
                var canvas = document.getElementById('the-canvas');
                var context = canvas.getContext('2d');
                canvas.height = viewport.height;
                canvas.width = viewport.width;
                $('#pageContainer').width(viewport.width + 1).height(viewport.height + 2);
                //
                // Render PDF page into canvas context
                //
                var renderContext = {
                    canvasContext: context,
                    viewport: viewport
                };
                //page.render(renderContext);

                page.render(renderContext).then(function () {
                    that.$forceUpdate(); // todo fix later
                    $(document).trigger("pagerendered");

                    // Render the annotation layer
                    if(that.showFormFields()) {
                        $("#annotation-layer").html('').show();
                        page.getAnnotations().then(function (annotationData) {
                            // Draw annotation layer
                            var pdf_canvas = $("#the-canvas");

                            // Canvas offset
                            var canvasOffset = pdf_canvas.offset();

                            // // Canvas height
                            var canvas_height = pdf_canvas.get(0).height;
                            //
                            // // Canvas width
                            var canvas_width = pdf_canvas.get(0).width;

                            // CSS for annotation layer
                            //$("#annotation-layer").css({ left: canvas_offset.left + 'px', top: canvas_offset.top + 'px', height: canvas_height + 'px', width: canvas_width + 'px' });
                            $("#annotation-layer").css({
                                left: 0 + 'px',
                                top: 0 + 'px',
                                height: canvas_height + 'px',
                                width: canvas_width + 'px'
                            });
// console.log('ADD',annotationData);
                            for (var i = 0; i < annotationData.length; i++) {
                                var ele = $('<div>');
                                var element = ele.get(0);
                                var rect = annotationData[i].rect;
                                element.style.left = (rect[0]) + 'px';
                                element.style.top = (canvas_height - rect[3]) + 'px';
                                element.style.width = (rect[2] - rect[0]) + 'px';
                                element.style.height = (rect[3] - rect[1]) + 'px';
                                element.style.position = 'absolute';
                                ele.attr('data-fieldname',annotationData[i].fieldName)
                                ele.text(annotationData[i].id + ' ' + annotationData[i].fieldName + ' ' + annotationData[i].fieldType);
                                ele.click(function(){
                                   Vue.copyToClipboard($(this).attr('data-fieldname'));
                                });
                                $("#annotation-layer").append(ele);
                            }
//                         pdfjsLib.AnnotationLayer.render({
//                             viewport: viewport.clone({dontFlip: true}),
//                             div: $("#annotation-layer").get(0),
//                             annotations: annotationData,
//                             page: page
//                         });
                            console.log('Annotations', annotationData);
                        });
                    }





                }, function () {
                    console.log("ERROR");
                });
            }
            ,
            //         showCoordinates: function () {
            //
            //             var maxPDFx = this.maxPDFx;
            //             var maxPDFy = this.maxPDFy;
            //             var offsetY = this.offsetY;
            //                 var validi = [];
            //                 var nonValidi = [];
            //
            //                 var maxHTMLx = $('#the-canvas').width();
            //                 var maxHTMLy = $('#the-canvas').height();
            //                 var paramContainerWidth = $('#parametriContainer').width();
            //
            //                 //recupera tutti i placholder validi
            //                 $('.drag-drop.can-drop').each(function (index) {
            //                     var x = parseFloat($(this).data("x"));
            //                     var y = parseFloat($(this).data("y"));
            //                     var valore = $(this).data("valore");
            //                     var descrizione = $(this).find(".descrizione").text();
            //
            //                     var pdfY = y * maxPDFy / maxHTMLy;
            //                     var posizioneY = maxPDFy - offsetY - pdfY;
            //                     var posizioneX = (x * maxPDFx / maxHTMLx) - paramContainerWidth;
            //
            //                     var val = {
            //                         "descrizione": descrizione,
            //                         "posizioneX": posizioneX,
            //                         "posizioneY": posizioneY,
            //                         "valore": valore
            //                     };
            //                     validi.push(val);
            //
            //                 });
            //
            //                 if (validi.length == 0) {
            //                     alert('No placeholder dragged into document');
            //                 } else {
            //                     alert(JSON.stringify(validi));
            //                 }
            //
            //         },
            //
            //         changePage: function(disabled, currentPage, delta) {
            //     if (disabled) {
            //         return;
            //     }
            //
            //     // recupera solo i parametri non posizionati in pagina
            //     var parametri = [];
            //     $(".drag-drop.dropped-out").each(function () {
            //         var valore = $(this).data("valore");
            //         var descrizione = $(this).find(".descrizione").text();
            //         parametri.push({
            //             valore: valore,
            //             descrizione: descrizione,
            //             posizioneX: -1000,
            //             posizioneY: -1000
            //         });
            //         $(this).remove();
            //     });
            //
            //     //svuota il contentitore
            //     $('#pager').remove();
            //     currentPage += delta;
            //     renderizzaPlaceholder(currentPage, parametri);
            //     //aggiorna lo stato dei pulsanti
            //     //aggiorna gli elementi visualizzati
            // },
            loadViewerTotal: function () {
                let that = this;
                this.$store.dispatch(ADD_BODY_CLASSNAME, "kt-page--loading");
                $.when(
                    $.getScript('https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.0.943/pdf.min.js'),
                    $.getScript('https://cdn.jsdelivr.net/npm/interactjs@1.9.13/dist/interact.min.js'),
                    $.getScript('https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.0.943/pdf.worker.min.js'),
                    // $.getScript('https://code.jquery.com/ui/1.12.1/jquery-ui.min.js'),
                    $.Deferred(function (deferred) {
                        $(deferred.resolve);
                    })
                ).done(function () {

                    pdfjsLib.GlobalWorkerOptions.workerSrc =
                        'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.0.943/pdf.worker.min.js';
                    that.loadViewer();

                });
            },
            showFormFields: function(){
                return UserService.isSuperDebugUser();
            },
            loadViewer: function () {
                var that = this;

                var maxPDFx = this.maxPDFx;
                var maxPDFy = this.maxPDFy;
                var offsetY = this.offsetY;

                'use strict';


// The workerSrc property shall be specified.
//
//                 var loadingTask = pdfjsLib.getDocument({
//                     url: 'http://localhost:8080/dummypdf.pdf',
//                     // cMapUrl: CMAP_URL,
//                     cMapPacked: true,
//                 });

                //
                // Asynchronous download PDF
                //
                var loadingTask = pdfjsLib.getDocument({data: this.pdfData});
                loadingTask.promise.then(function (pdf) {
                    that.pdf = pdf;

                    //
                    // Fetch the first page
                    //
                    pdf.getPage(that.pdfPagenum).then(function (page) {
                        that.$store.dispatch(REMOVE_BODY_CLASSNAME, "kt-page--loading");
                        that.render(page);
                        that.drawPlaceHolders();
                        // window.sspdf = page.getAnnotations();
                    });
                });


                // The dragging code for '.draggable' from the demo above
                // applies to this demo as well so it doesn't have to be repeated.

                if(!window.loadedInteract) {

                    // // enable draggables to be dropped into this
                    // if(window.loadedInteract) {
                    //     interact.removeDocument(document); //https://github.com/taye/interact.js/issues/598
                    // }
                    window.loadedInteract = true;
                    interact('.dropzone').unset();
                    interact('.dropzone').dropzone({
                        // only accept elements matching this CSS selector
                        accept: '.drag-element',
                        // Require a 100% element overlap for a drop to be possible
                        overlap: 1,

                        // listen for drop related events:

                        ondropactivate: function (event) {
                            // add active dropzone feedback
                            event.target.classList.add('drop-active');
                        },
                        ondragenter: function (event) {
                            var draggableElement = event.relatedTarget,
                                dropzoneElement = event.target;

                            // feedback the possibility of a drop
                            dropzoneElement.classList.add('drop-target');
                            draggableElement.classList.add('can-drop');
                            draggableElement.classList.remove('dropped-out');
                            //draggableElement.textContent = 'Dragged in';
                        },
                        ondragleave: function (event) {
                            // remove the drop feedback style
                            event.target.classList.remove('drop-target');
                            event.relatedTarget.classList.remove('can-drop');
                            event.relatedTarget.classList.add('dropped-out');
                            //event.relatedTarget.textContent = 'Dragged out';
                        },
                        ondrop: function (event) {
                            //event.relatedTarget.textContent = 'Dropped';
                        },
                        ondropdeactivate: function (event) {
                            // remove active dropzone feedback
                            event.target.classList.remove('drop-active');
                            event.target.classList.remove('drop-target');
                        }
                    });
//https://codepen.io/odahcam/pen/gRqKJj?editors=0010
                    //http://jsfiddle.net/dw3xdhch/
                    //https://github.com/taye/interact.js/issues/96


                    $("body").mousemove(function (e) {
                        vm.currentMouseX = e.pageX;
                        vm.currentMouseY = e.pageY;
                    });
                    $('.drag-element').unbind();
                    interact('.drag-element').unset();
                    interact('.drag-element')

                        .draggable({
                            // snap:{
                            //     targets: [ { x: 20, y: 20 } ],
                            //     offset: 'self'
                            // },
                            // allowFrom: '.indrag',
                            'manualStart': true,
                            modifiers: [
                                // interact.modifiers.restrictRect({
                                //     restriction: 'parent',
                                //     endOnly: true
                                // })
                            ],
                            listeners: {
                                move(event) {


                                    var target = event.target;

                                    var x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx;
                                    var y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;

                                    // translate the element
                                    target.style.webkitTransform = target.style.transform = 'translate(' + x + 'px, ' + y + 'px)';

                                    // update the posiion attributes
                                    target.setAttribute('data-x', x);
                                    target.setAttribute('data-y', y);

                                },
                                start(event) {
                                  window.enablePlaceHolderEditing(event.target);
                                },
                                end(event) {
                                    if (!event.target.classList.contains('can-drop')) {
                                        $(event.target).remove();
                                    } else {
                                        window.storePlaceHolder(event.target);
                                        window.enablePlaceHolderEditing(event.target);
                                    }
                                    console.log('Draggable: ', event);

                                }
                            }
                        })
                        .resizable({
                            margin: 10,
                            // resize from all edges and corners
                            edges: {left: true, right: true, bottom: true, top: true},

                            listeners: {
                                move(event) {
                                    var target = event.target
                                    var x = (parseFloat(target.getAttribute('data-x')) || 0);
                                    var y = (parseFloat(target.getAttribute('data-y')) || 0);

                                    // update the element's style
                                    target.style.width = event.rect.width + 'px';
                                    target.style.height = event.rect.height + 'px';
                                    //
                                    // target.setAttribute('data-width', event.rect.width);
                                    // target.setAttribute('data-height', event.rect.height);

                                    // translate when resizing from top or left edges
                                    if (!event.deltaRect) {
                                        return;
                                    }
                                    x += event.deltaRect.left;
                                    y += event.deltaRect.top;

                                    target.style.webkitTransform = target.style.transform =
                                        'translate(' + x + 'px,' + y + 'px)';

                                    target.setAttribute('data-x', x);
                                    target.setAttribute('data-y', y);

                                    //target.textContent = Math.round(event.rect.width) + '\u00D7' + Math.round(event.rect.height)
                                },
                                start(event) {
                                  window.enablePlaceHolderEditing(event.target);
                                },
                                end(event) {
                                    if (!event.target.classList.contains('can-drop')) {
                                        // $(event.target).remove();
                                    } else {
                                        window.storePlaceHolder(event.target);
                                        window.enablePlaceHolderEditing(event.target);
                                    }
                                    console.log('Draggable: ', event);

                                }
                            },
                            modifiers: [
                                // keep the edges inside the parent
                                // interact.modifiers.restrictEdges({
                                //     outer: 'parent'
                                // }),

                                // minimum size
                                interact.modifiers.restrictSize({
                                    min: {width: 1, height: 1}
                                })
                            ],

                            inertia: true
                        })
                        .on('move', function (event) {

                            var interaction = event.interaction;

// console.log(interaction);
                            // if the pointer was moved while being held down
                            // and an interaction hasn't started yet
                            if (interaction.pointerIsDown && !interaction.interacting() && event.currentTarget.classList.contains('drag-element-source')) {

                                var original = event.currentTarget;

                                // create a clone of the currentTarget element
                                var clone = event.currentTarget.cloneNode(true);

                                // Remove CSS class using JS only (not jQuery or jQLite) - http://stackoverflow.com/a/2155786/4972844
                                clone.className = clone.className.replace(/\bdrag-element-source\b/, 'drag-element-drag');

                                // insert the clone to the page
                                // TODO: position the clone appropriately
                                // document.getElementById('pageContainer-placeholders').appendChild(clone);
                                document.getElementById('todragcontainer').appendChild(clone);
                                //
                                // clone.setAttribute('data-x',$(original).position().left);
                                // clone.setAttribute('data-y',$(original).position().top);
                                // console.log(vm.currentMouseY);
                                clone.setAttribute('data-x', vm.currentMouseX - $('#selectorContainer').offset().left - 10);
                                // clone.setAttribute('data-x',vm.currentMouseX-$('#selectorContainer').offset().left-$('#pageContainer').offset().left+$('#selectorContainer').offset().left-10);
                                clone.setAttribute('data-y', vm.currentMouseY - $('#selectorContainer').offset().top - 20);

                                window.applyRightTransformationsPlaceholder(clone);
                                // start a drag interaction targeting the clone
                                interaction.start({name: 'drag'}, event.interactable, clone);
                                // interaction.start({name: 'resize',edges: { left: true, right: true, bottom: true, top: true }}, interact('.drag-element-drag'), clone);

                            } else if (!interaction.interacting()) {
                                if (event.offsetX > 10 && event.offsetY > 10 && (event.currentTarget.offsetWidth - event.offsetX) > 10 && (event.currentTarget.offsetHeight - event.offsetY) > 10) {
                                    interaction.start({name: 'drag'}, event.interactable, event.currentTarget);
                                }
                                // }else{
                                //     interaction.start({name: 'resize'}, event.interactable, event.currentTarget);
                                // }
                                // interaction.start({name: 'resize',edges: { left: true, right: true, bottom: true, top: true }}, interact('.drag-element-drag'), event.currentTarget);

                            }

                        });


                }


                //
                // interact('.drag-drop')
                //     .draggable({
                //         inertia: true,
                //         restrict: {
                //             restriction: "#selectorContainer",
                //             endOnly: true,
                //             elementRect: {top: 0, left: 0, bottom: 1, right: 1}
                //         },
                //         autoScroll: true,
                //         // dragMoveListener from the dragging demo above
                //         onmove: dragMoveListener,
                //     });
                //
                //
                // function dragMoveListener(event) {
                //     var target = event.target,
                //         // keep the dragged position in the data-x/data-y attributes
                //         x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx,
                //         y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;
                //
                //     // translate the element
                //     target.style.webkitTransform =
                //         target.style.transform = 'translate(' + x + 'px, ' + y + 'px)';
                //
                //     // update the posiion attributes
                //     target.setAttribute('data-x', x);
                //     target.setAttribute('data-y', y);
                // }
                //
                // // this is used later in the resizing demo
                // window.dragMoveListener = dragMoveListener;

                $(document).bind('pagerendered', function (e) {
                    // $('#pdfManager').show();
                    // var parametri = [{"idParametro":480,"descrizione":"RAPINA","valore":"X","nota":null},{"idParametro":481,"descrizione":"CAUSAL_G00","valore":"X","nota":null},{"idParametro":482,"descrizione":"A","valore":"A","nota":null},{"idParametro":483,"descrizione":"POSTA_REGISTRATA","valore":"X","nota":null},{"idParametro":484,"descrizione":"CD","valore":"CD","nota":null},{"idParametro":485,"descrizione":"DATA_ALERT","valore":"data alert","nota":null},{"idParametro":486,"descrizione":"UP","valore":"UP","nota":null},{"idParametro":488,"descrizione":"DATA_MP","valore":"DATA1","nota":null},{"idParametro":489,"descrizione":"AL_QUALITA","valore":"AL_QUALITA","nota":null},{"idParametro":490,"descrizione":"CAUSAL_G60","valore":"X","nota":null},{"idParametro":491,"descrizione":"DATA","valore":"DATA","nota":null},{"idParametro":492,"descrizione":"DATA_DENUNCIA","valore":"data denuncia","nota":null},{"idParametro":493,"descrizione":"DATA_SPEDIZIONE","valore":"data spedizione","nota":null},{"idParametro":494,"descrizione":"DATA_LAVORAZIONE","valore":"DATA_LAVORAZIONE","nota":null},{"idParametro":495,"descrizione":"NUMERO_FAX","valore":"NUMERO_FAX","nota":null},{"idParametro":496,"descrizione":"SMARRIMENTO","valore":"X","nota":null},{"idParametro":497,"descrizione":"STRUTT_ACCETTAZIONE","valore":"STRUTT_ACCETTAZIONE","nota":null},{"idParametro":498,"descrizione":"FURTO","valore":"X","nota":null},{"idParametro":499,"descrizione":"BARCODE","valore":"BARCODE","nota":null},{"idParametro":502,"descrizione":"CAUSA_MAGGIORE","valore":"X","nota":null},{"idParametro":503,"descrizione":"PACCHI","valore":"X","nota":null},{"idParametro":504,"descrizione":"TIPOLOGIA_EVENTO","valore":"TIPOLOGIA_EVENTO","nota":null},{"idParametro":505,"descrizione":"NOTE","valore":"NOTE","nota":null},{"idParametro":506,"descrizione":"DATA_RITROVAMENTO","valore":"data ritrovamento","nota":null},{"idParametro":507,"descrizione":"DATA_ACCETTAZIONE","valore":"DATA_ACCETTAZIONE","nota":null},{"idParametro":509,"descrizione":"AREA_LOGISTICA","valore":"AREA_LOGISTICA","nota":null},{"idParametro":511,"descrizione":"DA","valore":"DA","nota":null},{"idParametro":512,"descrizione":"DATA_DENUNCIA","valore":"DATA_DENUNCIA","nota":null},{"idParametro":513,"descrizione":"TIPOLOGIA_ALERT","valore":"TIPOLOGIA","nota":null},{"idParametro":515,"descrizione":"STRUTTURA_RILIEVO","valore":"STRUTTURA_RILIEVO","nota":null},{"idParametro":516,"descrizione":"STRUTTURA_DENUNCIA","valore":"STRUTTURA_DENUNCIA","nota":null},{"idParametro":517,"descrizione":"DISPACCIO","valore":"DISPACCIO","nota":null},{"idParametro":518,"descrizione":"CMP_CP","valore":"CMP_CP","nota":null},{"idParametro":520,"descrizione":"FURTO_EFFRAZIONE","valore":"X","nota":null}];
                    // $('#parametriContainer').empty();
                    // renderizzaPlaceholder(0, parametri);
                });

                // function renderizzaPlaceholder(currentPage, parametri) {
                //     var maxHTMLx = $('#the-canvas').width();
                //     var maxHTMLy = $('#the-canvas').height();
                //
                //     var paramContainerWidth = $('#parametriContainer').width();
                //     var yCounterOfGenerated = 0;
                //     var numOfMaxItem = 25;
                //     var notValidHeight = 30;
                //     var y = 0;
                //     var x = 6;
                //     var page = 0;
                //
                //
                //     var totalPages = Math.ceil(parametri.length / numOfMaxItem);
                //     for (var i=0; i < parametri.length; i++) {
                //         var param = parametri[i];
                //         var page = Math.floor(i / numOfMaxItem);
                //         var display = currentPage == page ? "block" : "none";
                //
                //         if (i > 0 && i % numOfMaxItem == 0) {
                //             yCounterOfGenerated = 0;
                //         }
                //
                //         var classStyle = "";
                //         var valore = param.valore;
                //         // il placeholder non è valido: lo incolonna a sinistra
                //
                //         if (i > 0 && i % numOfMaxItem == 0) {
                //             yCounterOfGenerated = 0;
                //         }
                //
                //         var classStyle = "";
                //         var valore = param.valore;
                //         // il placeholder non è valido: lo incolonna a sinistra
                //         y = yCounterOfGenerated;
                //         yCounterOfGenerated += notValidHeight;
                //         classStyle = "drag-drop dropped-out";
                //
                //
                //         $("#parametriContainer").append('<div class="' + classStyle + '" data-id="-1" data-page="' + page + '" data-toggle="' + valore + '" data-valore="' + valore + '" data-x="' + x + '" data-y="' + y + '" style="transform: translate(' + x + 'px, ' + y + 'px); display:' + display + '">  <span class="circle"></span><span class="descrizione">' + param.descrizione + ' </span></div>');
                //     }
                //
                //     y = notValidHeight * (numOfMaxItem + 1);
                //     var prevStyle = "";
                //     var nextStyle = "";
                //     var prevDisabled = false;
                //     var nextDisabled = false;
                //     if (currentPage == 0) {
                //         prevStyle = "disabled";
                //         prevDisabled = true;
                //     }
                //
                //     if (currentPage >= totalPages - 1 || totalPages == 1) {
                //         nextDisabled = true;
                //         nextStyle = "disabled";
                //     }
                //
                //     //Aggiunge la paginazione
                //     $("#parametriContainer").append('<ul id="pager" class="pager" style="transform: translate(' + x + 'px, ' + y + 'px); width:200px;"><li v-on:click="this.changePage(' + prevDisabled + ',' + currentPage + ',-1)" class="page-item ' + prevStyle + '"><span>«</span></li><li v-on:click="changePage(' + nextDisabled + ',' + currentPage + ',1)" class="page-item ' + nextStyle + '" style="margin-left:10px;"><span>&raquo;</span></li></ul>');
                //
                // }
                //
                // function renderizzaInPagina(parametri) {
                //     var maxHTMLx = $('#the-canvas').width();
                //     var maxHTMLy = $('#the-canvas').height();
                //
                //     var paramContainerWidth = $('#parametriContainer').width();
                //     var yCounterOfGenerated = 0;
                //     var numOfMaxItem = 26;
                //     var notValidHeight = 30;
                //     var y = 0;
                //     var x = 0;
                //     for (i = 0; i < parametri.length; i++) {
                //         var param = parametri[i];
                //
                //         var classStyle = "drag-drop can-drop";
                //         var valore = param.valore;
                //         // il placeholder non è valido: lo incolonna a sinistra
                //
                //         var pdfY = maxPDFy - param.posizioneY - offsetY;
                //         y = (pdfY * maxHTMLy) / maxPDFy;
                //         x = ((param.posizioneX * maxHTMLx) / maxPDFx) + paramContainerWidth;
                //
                //         $("#parametriContainer").append('<div class="' + classStyle + '" data-id="' + param.idParametroModulo + '" data-toggle="' + valore + '" data-valore="' + valore + '" data-x="' + x + '" data-y="' + y + '" style="transform: translate(' + x + 'px, ' + y + 'px);">  <span class="circle"></span><span class="descrizione">' + param.descrizione + ' </span></div>');
                //     }
                // }


            }
        }
    }
    ;
</script>
